import type {LangT} from '@freckle/educator-entities/ts/common/helpers/languages'
import type {Leaderboard} from '@freckle/educator-entities/ts/common/helpers/leaderboard'
import type {TeacherRole} from '@freckle/educator-entities/ts/common/helpers/teacher-role'
import type {ElaLevelingProgramT} from '@freckle/educator-entities/ts/ela/common/logic/ela-leveling-program'
import {fancyClient, extractData, ensureOk} from '@freckle/educator-entities/ts/openapi-clients'
import type {StudentNameSortFieldT} from '@freckle/educator-entities/ts/users/models/teacher'
import type {TeacherAttrs} from '@freckle/classroom/ts/users/models/teacher'
import {parse} from '@freckle/classroom/ts/users/models/teacher'

/* Get */

export function fetchCurrentTeacher(): Promise<TeacherAttrs> {
  return fancyClient.GET('/2/teachers/me').then(extractData).then(parse)
}

/* Patch */

export type PatchParamT = {
  role?: TeacherRole | null | undefined
  onboardingGrades?: Array<number>
  focusMode?: boolean
  elaLevelingProgram?: ElaLevelingProgramT | null | undefined
  firstName?: string
  lastName?: string
  googleSignin?: false
  email?: string
  mathStandardSetId?: string
  elaStandardSetId?: string | null | undefined
  studentNameSortField?: StudentNameSortFieldT
  leaderboard?: Leaderboard
  language?: LangT
  countryCode?: string
  schoolId?: number | null | undefined
}

export function updateTeacher(teacherId: number, patchParams: PatchParamT): Promise<TeacherAttrs> {
  return fancyClient
    .PATCH('/2/teachers/{TeacherR-TeacherId}', {
      params: {
        path: {
          'TeacherR-TeacherId': teacherId,
        },
      },
      body: patchParams,
    })
    .then(extractData)
    .then(parse)
}

export async function deleteTeacher(teacherId: number): Promise<void> {
  await fancyClient
    .DELETE('/2/teachers/{TeacherR-TeacherId}', {
      params: {
        path: {
          'TeacherR-TeacherId': teacherId,
        },
      },
    })
    .then(ensureOk)
}
